// extracted by mini-css-extract-plugin
module.exports = {"wrap":"structure_wrap__3E4uE","left":"structure_left__31JTX","right":"structure_right__3eAX5"};